// Staff Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get usersList from backend then update usersList in vuex store ***** //
export const updateStaffList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('users_index', { params: params })
    commit('updateStaffList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch staff member from backend ***** //
export const fetchStaffMemberInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  // payload = 1000
  try {
    const result = await Axios.get(`users_show/${payload}`)
    commit('fetchStaffMemberInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch staff member from backend ***** //
export const fetchStaffMemberSubOutlet = async ({ commit }) => {
  // payload = 1000
  try {
    const result = await Axios.get(`change_outlets_list`)
    const list = []
    result.data.data.forEach(r => {
      list.push({ text: r.outlet_name, value: r.outlet_id })
    })
    commit('fetchStaffMemberSubOutlet', list)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add staff member ***** //
export const addStaffMember = async (ignored, payload = null) => {
  try {
    await Axios.post('users_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update staff member info ***** //
export const updateStaffMemberInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`users_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Update staff member info ***** //
export const switchStaffMemberOutlet = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.patch(`outlets_change/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Switched Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Update staff member info ***** //
export const updateStaffProfileInfo = async (ignored, payload = null) => {
  try {
    await Axios.post(`update_profile`, payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    console.log(error)

    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Change staff member password ***** //
export const changeStaffMemberPassword = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`change_password/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, password did not change')
  }
}

// ***** Assign permissions to the staff member ***** //
export const assignPermissions = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    await Axios.post(`assign_roles/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, password did not change')
  }
}

// ***** Get all available permissions ***** //
export const fetchAllPermissions = async ({ commit }) => {
  try {
    const result = await Axios.get('sidebars')
    commit('updatePermissionsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching permissions failed')
  }
}

// ***** Delete staff member ***** //
export const deleteStaffMember = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`users_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullStaffsList = async ({ commit }) => {
  let staffsList = []

  try {
    const result = await Axios.get('user_list')
    result.data.data.forEach(user => {
      staffsList.push({ value: user.user_id, text: user.user_name })
    })
    commit('setFullStaffsList', staffsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

export const setFullOutletStaffsList = async ({ commit }) => {
  let staffsList = []

  try {
    const result = await Axios.get('all_user_list')
    result.data.data.forEach(user => {
      staffsList.push({ value: user.user_id, text: user.user_name })
    })
    commit('setFullOutletStaffsList', staffsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Update staff password info ***** //
export const changePassword = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`profile_change_password/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}
